import Base from './base';


class Static extends Base {

    states() {
        return this.get('static/states');
    }

    counties(stateId:number){
        return this.get('static/counties', {stateId})
    }

    courts(countyId: number) {
        return this.get('static/courts', {countyId})
    }

    departments(courtId: number) {
        return this.get('static/departments', {courtId})
    }

    caseTypes() {
        return this.get('static/case-types');
    }

    caseSubTypes(caseTypeId:number){
        return this.get('static/case-sub-types', {caseTypeId})
    }

}

export default new Static();
